import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const getCookieValue = (name: string): string | null => {
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
};

const originalFetch = window.fetch.bind(window);
window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
  const requestUrl = (() => {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.toString();
    if (typeof Request !== 'undefined' && input instanceof Request) return input.url;
    return String(input);
  })();
  const requestMethod =
    init?.method ||
    (typeof Request !== 'undefined' && input instanceof Request ? input.method : undefined) ||
    'GET';
  const method = requestMethod.toUpperCase();
  const isApiRequest = requestUrl.startsWith('/api') || requestUrl.includes('/api/');

  if (!isApiRequest) {
    return originalFetch(input, init);
  }

  const headers = new Headers(
    typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined
  );
  if (init?.headers) {
    const initHeaders = new Headers(init.headers);
    initHeaders.forEach((value, key) => headers.set(key, value));
  }

  const csrfToken = getCookieValue('csrf_token');

  if (csrfToken && method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS') {
    headers.set('X-CSRF-Token', csrfToken);
  }

  const credentials =
    init?.credentials ||
    (typeof Request !== 'undefined' && input instanceof Request ? input.credentials : undefined) ||
    'include';

  return originalFetch(input, {
    ...init,
    credentials,
    headers
  });
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
